import Main from './components/Main'

export default [
  {
    path: '/auth',
    component: Main,
    name: 'auth',
    meta: {
      auth: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/app/domains/auth/routes.js